"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.makeBridges = void 0;
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var cache_1 = require("../../../cache");
var cached_1 = require("../api/cached");
var js_broadcast_1 = require("../js-broadcast");
var js_createTransaction_1 = __importStar(require("../js-createTransaction"));
var js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
var js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
var js_preload_1 = require("../js-preload");
var js_prepareTransaction_1 = require("../js-prepareTransaction");
var js_signOperation_1 = require("../js-signOperation");
var js_synchronization_1 = require("../js-synchronization");
var utils_1 = require("../utils");
var serialization_1 = require("../serialization");
function makePrepare(getChainAPI) {
    function prepareTransaction(mainAccount, transaction) {
        return __awaiter(this, void 0, void 0, function () {
            var config, chainAPI;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            endpoint: (0, utils_1.endpointByCurrencyId)(mainAccount.currency.id)
                        };
                        return [4 /*yield*/, getChainAPI(config)];
                    case 1:
                        chainAPI = _a.sent();
                        return [2 /*return*/, (0, js_prepareTransaction_1.prepareTransaction)(mainAccount, transaction, chainAPI)];
                }
            });
        });
    }
    return prepareTransaction;
}
function makeSyncAndScan(getChainAPI) {
    var _this = this;
    var getAccountShape = function (info) { return __awaiter(_this, void 0, void 0, function () {
        var config, chainAPI;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        endpoint: (0, utils_1.endpointByCurrencyId)(info.currency.id)
                    };
                    return [4 /*yield*/, getChainAPI(config)];
                case 1:
                    chainAPI = _a.sent();
                    return [2 /*return*/, (0, js_synchronization_1.getAccountShapeWithAPI)(info, chainAPI)];
            }
        });
    }); };
    return {
        sync: (0, jsHelpers_1.makeSync)({ getAccountShape: getAccountShape }),
        scan: (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: getAccountShape })
    };
}
function makeEstimateMaxSpendable(getChainAPI) {
    function estimateMaxSpendable(arg) {
        return __awaiter(this, void 0, void 0, function () {
            var account, parentAccount, currencyId, config, api;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        account = arg.account, parentAccount = arg.parentAccount;
                        currencyId = account.type === "Account"
                            ? account.currency.id
                            : parentAccount === null || parentAccount === void 0 ? void 0 : parentAccount.currency.id;
                        if (currencyId === undefined) {
                            throw new Error("currency not found");
                        }
                        config = {
                            endpoint: (0, utils_1.endpointByCurrencyId)(currencyId)
                        };
                        return [4 /*yield*/, getChainAPI(config)];
                    case 1:
                        api = _a.sent();
                        return [2 /*return*/, (0, js_estimateMaxSpendable_1["default"])(arg, api)];
                }
            });
        });
    }
    var cacheKeyByAccSpendableBalance = function (_a) {
        var _b;
        var account = _a.account, transaction = _a.transaction;
        if (account.type === "ChildAccount") {
            throw new Error("unsupported account type");
        }
        return "".concat(account.id, ":").concat(account.spendableBalance.toString(), ":tx:").concat((_b = transaction === null || transaction === void 0 ? void 0 : transaction.model.kind) !== null && _b !== void 0 ? _b : "<no transaction>");
    };
    return (0, cache_1.makeLRUCache)(estimateMaxSpendable, cacheKeyByAccSpendableBalance, (0, cached_1.minutes)(5));
}
function makeBroadcast(getChainAPI) {
    var _this = this;
    return function (info) { return __awaiter(_this, void 0, void 0, function () {
        var config, api;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        endpoint: (0, utils_1.endpointByCurrencyId)(info.account.currency.id)
                    };
                    return [4 /*yield*/, getChainAPI(config)];
                case 1:
                    api = _a.sent();
                    return [2 /*return*/, (0, js_broadcast_1.broadcastWithAPI)(info, api)];
            }
        });
    }); };
}
function makeSign(getChainAPI) {
    return function (info) {
        var config = {
            endpoint: (0, utils_1.endpointByCurrencyId)(info.account.currency.id)
        };
        var api = function () { return getChainAPI(config); };
        return (0, js_signOperation_1.signOperationWithAPI)(info, api);
    };
}
function makePreload(getChainAPI) {
    var preload = function (currency) {
        var config = {
            endpoint: (0, utils_1.endpointByCurrencyId)(currency.id)
        };
        var api = function () { return getChainAPI(config); };
        return (0, js_preload_1.preloadWithAPI)(currency, api);
    };
    return preload;
}
function makeBridges(_a) {
    var getAPI = _a.getAPI, getQueuedAPI = _a.getQueuedAPI, getQueuedAndCachedAPI = _a.getQueuedAndCachedAPI;
    var _b = makeSyncAndScan(getQueuedAPI), sync = _b.sync, scan = _b.scan;
    var accountBridge = {
        createTransaction: js_createTransaction_1["default"],
        updateTransaction: js_createTransaction_1.updateTransaction,
        estimateMaxSpendable: makeEstimateMaxSpendable(getQueuedAndCachedAPI),
        getTransactionStatus: js_getTransactionStatus_1["default"],
        sync: sync,
        receive: (0, jsHelpers_1.makeAccountBridgeReceive)(),
        prepareTransaction: makePrepare(getQueuedAndCachedAPI),
        broadcast: makeBroadcast(getAPI),
        signOperation: makeSign(getAPI),
        assignFromAccountRaw: serialization_1.assignFromAccountRaw,
        assignToAccountRaw: serialization_1.assignToAccountRaw
    };
    var currencyBridge = {
        preload: makePreload(getQueuedAndCachedAPI),
        hydrate: js_preload_1.hydrate,
        scanAccounts: scan
    };
    return {
        currencyBridge: currencyBridge,
        accountBridge: accountBridge
    };
}
exports.makeBridges = makeBridges;
//# sourceMappingURL=bridge.js.map